import { render, staticRenderFns } from "./MedcardShare.vue?vue&type=template&id=4ca1fdd5"
import script from "./MedcardShare.vue?vue&type=script&lang=ts"
export * from "./MedcardShare.vue?vue&type=script&lang=ts"
import style0 from "./MedcardShare.vue?vue&type=style&index=0&id=4ca1fdd5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseNumberMarker: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseNumberMarker.vue').default,BaseBtn: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseBtn.vue').default,BaseFullscreenDialog: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseFullscreenDialog.vue').default})
